var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('v-fade-transition',[(!_vm.loadingData)?_c('div',{staticClass:"home"},[_c('div',{staticClass:"content"},[_c('v-col',{staticClass:"background",attrs:{"no-gutters":"","cols":"12"}},[_c('RenderBlocks',{attrs:{"blocks":_vm.blocks}})],1)],1)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }